export enum GroupOperationError {
	DeviceNotFound = 'DEVICE_NOT_FOUND',
	GroupNameInvalid = 'GROUP_NAME_INVALID',
	GroupNameNotUnique = 'GROUP_NAME_NOT_UNIQUE',
	GroupNotEmpty = 'GROUP_NOT_EMPTY',
	GroupNotFound = 'GROUP_NOT_FOUND',
	MaxGroupsLimitReached = 'MAX_GROUPS_LIMIT_REACHED',
	OrgTreeDepthLimitReached = 'ORG_TREE_DEPTH_LIMIT_REACHED',
	OrgTreeWouldBeInvalid = 'ORG_TREE_WOULD_BE_INVALID',
	SpaceNotFound = 'SPACE_NOT_FOUND',
	Unknown = 'UNKNOWN'
}
